// Generated by purs version 0.15.15
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Ouroboros_Models_Brands_DocumentUploadFileName from "../Ouroboros.Models.Brands.DocumentUploadFileName/index.js";
import * as Ouroboros_Models_Brands_FileSizeBytes from "../Ouroboros.Models.Brands.FileSizeBytes/index.js";
import * as Ouroboros_Models_Brands_MimeType from "../Ouroboros.Models.Brands.MimeType/index.js";
import * as Ouroboros_Models_Brands_ProjectDocumentClassification from "../Ouroboros.Models.Brands.ProjectDocumentClassification/index.js";
import * as Ouroboros_Models_Brands_ProjectDocumentType from "../Ouroboros.Models.Brands.ProjectDocumentType/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var buildPresignProjectDocumentsRequest = function (files) {
    return {
        uploads: map(function (file) {
            return {
                filename: Ouroboros_Models_Brands_DocumentUploadFileName.makeDocumentUploadFileName(file.filename),
                file_size: Ouroboros_Models_Brands_FileSizeBytes.makeFileSizeBytes(file.file_size),
                mime_type: Ouroboros_Models_Brands_MimeType.makeMimeType("application/octet-stream"),
                document_type: Ouroboros_Models_Brands_ProjectDocumentType.makeProjectDocumentType("uploaded"),
                suggested_classification: Ouroboros_Models_Brands_ProjectDocumentClassification.makeProjectDocumentClassification("unknown"),
                batch_id: Data_Maybe.Nothing.value,
                source_document_ids: [  ]
            };
        })(files)
    };
};
export {
    buildPresignProjectDocumentsRequest
};
//# sourceMappingURL=index.js.map
